// extracted by mini-css-extract-plugin
export var blue = "_3k-f";
export var brand = "_3k-b";
export var darkGrey = "_3k-e";
export var disabled = "_3k-4";
export var disabledSubtle = "_3k-5";
export var error = "_3k-6";
export var green = "_3k-g";
export var grey = "_3k-d";
export var icon = "_3k-0";
export var inherit = "_3k-a";
export var lightGrey = "_3k-c";
export var orange = "_3k-i";
export var pink = "_3k-k";
export var primary = "_3k-1";
export var purple = "_3k-l";
export var red = "_3k-j";
export var secondary = "_3k-2";
export var success = "_3k-9";
export var tertiary = "_3k-3";
export var warning = "_3k-7";
export var warningSecondary = "_3k-8";
export var white = "_3k-m";
export var yellow = "_3k-h";